import UAECountry from '../Components/Forms/Data/UAECountry.json'

export const uaeAreaCountries = country => {
    return UAECountry.find(item => item.name === country || item.native_name === country)
}
